export default "__VITE_ASSET__DCsziU1T__"